import React, { useState, useRef } from "react";
import { timKiemSanBay } from "../../services/flightService";

export default function AirportSearch({ airportList = [], onSelect, selectingField }) {
  const [activeTab, setActiveTab] = useState(airportList[0]?.id || null);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const debounceRef = useRef();

  const activeCountry = airportList.find((item) => item.id === activeTab) || airportList[0];

  const fetchSearch = async (text) => {
    setIsSearching(true);
    try {
      const data = await timKiemSanBay(text);
      setSearchResults(data.data || []);
    } catch (e) {
      setSearchResults([]);
    }
  };

  const handleSearch = (text) => {
    setSearchText(text);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!text) {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }
    debounceRef.current = setTimeout(() => {
      fetchSearch(text);
    }, 300);
  };

  return (
    <div>
      {/* Inline style for hover effects */}
      <style>
        {`
          .airport-tab-btn {
            transition: background 0.2s, color 0.2s;
          }
          .airport-tab-btn:not(:disabled):hover {
            background: #f0f7ff !important;
            color: #0056b3 !important;
          }
          .airport-li:hover {
            background: #f5f5f5;
            color: #007bff;
          }
        `}
      </style>
      {/* Search input */}
      <div style={{ marginBottom: 12 }}>
        <input
          type="text"
          placeholder="Tìm kiếm sân bay..."
          value={searchText}
          onChange={e => handleSearch(e.target.value)}
          style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
        />
      </div>
      <div style={{ maxWidth: 600, height: 400, overflow: "auto" }}>
        {/* Nếu đang search và có kết quả thì show kết quả search */}
        {isSearching && searchText && (
          <div>
            {searchResults.length === 0 && <div>Không tìm thấy sân bay phù hợp.</div>}
            {searchResults.length > 0 && (
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {searchResults.map((airport) => (
                  <li
                    key={airport.id}
                    className="airport-li"
                    style={{
                      cursor: "pointer",
                      padding: "8px 0",
                      borderBottom: "1px solid #eee"
                    }}
                    onClick={() => onSelect && onSelect({
                      code: airport.ten_viet_tat,
                      label: `${airport.tinh_thanh} (${airport.ten_viet_tat})`,
                      country: airport?.quoc_gia?.ten || "",
                      ...airport
                    })}
                  >
                    {airport.tinh_thanh} <b>({airport.ten_viet_tat})</b>
                    {airport?.quoc_gia?.ten ? <span style={{ marginLeft: 8 }}>{airport.quoc_gia.ten}</span> : null}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
        {/* Nếu không search hoặc không có kết quả search thì show tab */}
        {!isSearching || !searchText ? (
          <>
            {airportList.length === 0 && <div>Không có dữ liệu sân bay.</div>}
            {airportList.length > 0 && (
              <>
                {/* Tabs */}
                <div style={{ display: "flex", borderBottom: "1px solid #eee", marginBottom: 12, width: "600px" }}>
                  {airportList.map((country) => (
                    <button
                      key={country.id}
                      className="airport-tab-btn"
                      onClick={() => setActiveTab(country.id)}
                      style={{
                        padding: "8px 16px",
                        border: "none",
                        borderBottom: activeTab === country.id ? "2px solid #007bff" : "2px solid transparent",
                        background: "none",
                        fontWeight: activeTab === country.id ? "bold" : "normal",
                        color: activeTab === country.id ? "#007bff" : "#333",
                        cursor: "pointer"
                      }}
                    >
                      {country.ten}
                    </button>
                  ))}
                </div>
                {/* Tab content */}
                {activeCountry && (
                  <div style={{ display: "flex", gap: 24 }}>
                    {activeCountry.khu_vuc && activeCountry.khu_vuc.map((region) => (
                      <div key={region.id} style={{ minWidth: 180 }}>
                        <div style={{ fontWeight: "bold", marginBottom: 8 }}>{region.ten}</div>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          {region.san_bay && region.san_bay.map((airport) => (
                            <li
                              key={airport.id}
                              className="airport-li"
                              style={{ cursor: "pointer", padding: "4px 2px" }}
                              onClick={() => onSelect && onSelect({
                                code: airport.ten_viet_tat,
                                label: `${airport.tinh_thanh} (${airport.ten_viet_tat})`,
                                country: airport?.quoc_gia?.ten || "",
                                ...airport
                              })}
                            >
                              {airport.tinh_thanh} <b>({airport.ten_viet_tat})</b>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
}